import { createFileRoute, Outlet } from "@tanstack/react-router";

// Subscribers becomes a layout route so one subscriber can have a page of its
// own — the same pattern as `posts.tsx`, `sending.tsx` and `developer.tsx`.
// `subscribers.tsx`, not `_subscribers.tsx`: `/subscribers` has to stay a real
// segment its children nest under, rather than a pathless layout contributing
// none.
//
// `subscribers/index.tsx` renders the list (moved here unchanged from this
// file's old direct component); `subscribers/$domain/$email.tsx` is one
// subscriber. Two params because a subscriber's key is
// `(workspaceId, domain, email)` — the same primary key `getSubscriberHistory`
// and `updateEmailName` already take. The email alone does not identify a row.
//
// The Subscribers nav entry deliberately has NO `exact: true` (unlike Posts),
// so `AppLink`'s default prefix match keeps the sidebar row current while a
// subscriber is open. No other nav entry's `to` is a prefix of this path.
//
// `component: Outlet`, not `() => <Outlet />`: the inline arrow is anonymous
// in React DevTools and in error-boundary stacks. The three layout routes
// above name the same component, and `dashboard-route-parity.test.tsx` pins
// the identity for all four.
export const Route = createFileRoute("/dashboard/w/$workspaceId/subscribers")({
  component: Outlet,
});
